import React, { useState } from "react";

const AboutMyStore = ({ aboutUs, setAboutUs }) => {
  // const [textareaValue, setTextareaValue] = useState("");

  const handleTextareaChange = (event) => {
    setAboutUs(event.target.value);
  };

  return (
    // <div className="w-full h-[900px] flex items-center justify-center">
    <div className="w-[891px] h-[620px] rounded-b-[5px] bg-white pt-[26px] flex flex-col gap-y-[14px]">
      <h3 className="w-[152px] h-[21px] text-black font-semibold text-[14px] text-start">
        Tell us about yourself
      </h3>

      <textarea
        name="BankAddress"
        id="BankAddress"
        rows={5}
        value={aboutUs}
        onChange={handleTextareaChange}
        placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "
        className="w-[892px] h-[345px] p-[20px] border rounded-[5px] placeholder:w-[852px] placeholder:h-[305px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
      ></textarea>
    </div>
    // </div>
  );
};

export default AboutMyStore;
